module.exports = __webpack_public_path__ + "media/mfg/news-b4a2606b.jpg";